import { CopyOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import PropTypes from "prop-types";

function CloneButton({ setOpenCloneModal }) {
  return (
    <div>
      <Tooltip title="Clone">
        <Button
          icon={<CopyOutlined />}
          onClick={() => setOpenCloneModal(true)}
        />
      </Tooltip>
    </div>
  );
}

CloneButton.propTypes = {
  setOpenCloneModal: PropTypes.func.isRequired,
};
export { CloneButton };
